/**
 * FloorplansList Override (Dietz Property Group)
 *
 * Replaces the parent theme's FloorplansList with a thin wrapper that
 * renders only the `apartment-sync` block. No other content is included
 * — the block is the entire section.
 */

import {
  useBlockSlot,
  EditableToken,
  SectionContextProvider,
} from '@vibesites/runtime/react';
import type { ComponentContentSchema } from '@vibesites/runtime';

export const contentSchema: ComponentContentSchema = {
  slot: 'FloorplansList',
  displayName: 'Floor Plans List',
  tokens: {
    'floorplanslist.block': {
      label: 'Floorplans Block',
      type: 'block',
      defaultValue: 'apartment-sync',
      description:
        'The block rendered in place of the floorplans list. Defaults to the ApartmentSync (Repli360) widget.',
    },
  },
};

export function FloorplansList() {
  const blockSlot = useBlockSlot('floorplanslist.block', {
    defaultValue: 'apartment-sync',
  });

  return (
    <section
      id="floorplans"
      data-vibesite-slot="FloorplansList"
      style={{
        scrollMarginTop:
          'calc(var(--header-height, 64px) + var(--offer-banner-height, 0px))',
      }}
    >
      <EditableToken
        path="floorplanslist.block"
        type="block"
        label="Floorplans Block"
        as="div"
      >
        {blockSlot ? (
          <SectionContextProvider sectionId={blockSlot.sectionId}>
            <blockSlot.BlockComponent sectionId={blockSlot.sectionId} />
          </SectionContextProvider>
        ) : null}
      </EditableToken>
    </section>
  );
}

(FloorplansList as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FloorplansList;
